import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import type { Observable } from '@/js/libs/observable';
import { useSubscribe } from '@/js/libs/observable';
import { Button, Icons } from '@/js/libs/ui/src/V2';

interface ClearFiltersButtonProps {
  areFiltersClearable$: Observable<boolean>;
  clearFilters: () => void;
}

export const ClearFiltersButton = ({ areFiltersClearable$, clearFilters }: ClearFiltersButtonProps) => {
  const [t] = useTranslation(['backend', 'common']);
  const { colors } = useTheme();
  const areFiltersClearable = useSubscribe(areFiltersClearable$);

  return areFiltersClearable ? (
    <Button onClick={clearFilters} ghost dataTestId='clear-filters-button'>
      <Icons.Clear color={colors.critical100} />
      {t('common:CLEAR_FILTERS')}
    </Button>
  ) : null;
};
